import { render, staticRenderFns } from "./foreignBillTab.vue?vue&type=template&id=99b574be&scoped=true&"
import script from "./foreignBillTab.vue?vue&type=script&lang=js&"
export * from "./foreignBillTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b574be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99b574be')) {
      api.createRecord('99b574be', component.options)
    } else {
      api.reload('99b574be', component.options)
    }
    module.hot.accept("./foreignBillTab.vue?vue&type=template&id=99b574be&scoped=true&", function () {
      api.rerender('99b574be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/financeManage/foreignBillTab.vue"
export default component.exports